import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const initialState = () => {
    return {
        open: false
    };
};

const getters = {
    state: state => state,
    open: state => state.open
}

const actions = {
    resetState: ({ commit }) => commit('resetState'),
    updateOpen: ({ commit }, payload) => commit('setOpen', payload),
    toggleOpen: ({ commit }) => commit('toggleOpen')
}

const mutations = {
    resetState(state) {
        Object.assign(state, initialState());
    },
    setOpen(state, payload) {
        state.open = payload;
    },
    toggleOpen(state) {
        state.open = !state.open;
    }
}

const modules = { }

export default {
    namespaced: true,
    state: initialState(),
    getters,
    mutations,
    actions,
    modules
};


// WEBPACK FOOTER //
// ./src/store/modules/navigation.js